import PlansPage from './PlansPage'

export { PlansPage }
export default PlansPage
